import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/exam-duration-calculation-methods/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const examDurationCalculationMethods = {
  getAll: apiPathFunc(pathBase),
} as const;
